module.exports = __webpack_public_path__ + "static/media/mqtt_protocol.f3900980.md";